module.exports = __webpack_public_path__ + "img/phone-two.3b37c0d2.png";